export const isNullOrUndefined = (val: null | undefined | string | number) =>
  val === null || val === undefined;
